import { axiosInstance } from "./";

const reviewRequestsList = async ({ params }) =>
  await axiosInstance.get("/api/Request/GetRequests", {
    params,
    paramsSerializer: { indexes: null }
  });

const approvedProductsList = async ({ params }) =>
  await axiosInstance.get("/api/Product/Get", {
    params,
    paramsSerializer: { indexes: null }
  });

const approveProductRequest = async (id) =>
  await axiosInstance.put("/api/Request/ApproveRequest", { id });

const rejectProductRequest = async (data) =>
  await axiosInstance.put("/api/Request/RejectRequest", data);

const getProductDetails = async (id) =>
  await axiosInstance.get(`/api/Product/GetById/${id}`);

const getProductVersionDetails = async (id) =>
  await axiosInstance.get(`/api/Product/GetVersionById/${id}`);

export {
  reviewRequestsList,
  approvedProductsList,
  approveProductRequest,
  rejectProductRequest,
  getProductDetails,
  getProductVersionDetails
};
